export const HD = window.devicePixelRatio > 1;

export const ajaxUrl = window.blogUrl + "/wp-admin/admin-ajax.php";
